import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/awsImport',
  component: layout,
  meta: {
    funcID: 'E0002',
    PID: 'E00'
  },
  children: ((pre) => [
    {
      path: 'orderData',
      name: `${pre}orderData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000201',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/orderData')
    },
    {
      path: 'inventoryData',
      name: `${pre}inventoryData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000202',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/inventoryData')
    },
    {
      path: 'advertisingData',
      name: `${pre}advertisingData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000203',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/advertisingData')
    },
    {
      path: 'skuData',
      name: `${pre}skuData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000204',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/skuData')
    },
    {
      path: 'storeData',
      name: `${pre}storeData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000205',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/storeData')
    },
    {
      path: 'listingData',
      name: `${pre}listingData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000206',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/listingData')
    },
    {
      path: 'settlementData',
      name: `${pre}settlementData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000208',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/settlementData')
    },
    {
      path: 'skuErrorData',
      name: `${pre}skuErrorData`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000207',
        PID: 'E00'
      },
      component: () => import('@/views/ecom/awsImport/skuErrorData')
    },
  ])('ecom-awsImport-')
}
